export default {"src":"/_next/static/media/location-pin-gradient.11a1a681.svg","height":32,"width":32};